import Row from "../row"

const Popup = ({ children, className = 'popup__normal' }) => {
    return (
        <div className={`popup ${className}`}>
            <div className="popup__inner">
                { children }
            </div>
        </div>
    )
}

Popup.Header = ({ children }) => {
    return (
        <div className="popup__header">
            { children }
        </div>
    )
}

Popup.Content = ({ children, className = '' }) => {
    return (
        <div className={`popup__content ${className}`}>
            { children }
        </div>
    )
}

Popup.Buttons = ({ children, className = '' }) => {
    return (
        <Row gap="20px" className={`popup__buttons ${className}`}>
            { children }
        </Row>
    )
}

export default Popup;
